export default "__VITE_ASSET__CymK1k8x__"